import { render } from "./LoginDash.vue?vue&type=template&id=08973584&scoped=true"
import script from "./LoginDash.vue?vue&type=script&lang=js"
export * from "./LoginDash.vue?vue&type=script&lang=js"

import "./LoginDash.vue?vue&type=style&index=0&id=08973584&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08973584"]])

export default __exports__